export default __webpack_public_path__ + "assets/home-one-three-small.ba42e1509d94eb816e5a0d32f051d977.png";